import { useState } from 'react';
import { type GlobalToken, Grid, theme } from 'antd';

const { useBreakpoint } = Grid;

const getInitialBreakpoints = (tokens: GlobalToken): ReturnType<typeof useBreakpoint> => {
  if (typeof window === 'undefined') {
    return {};
  }
  const { screenXSMax, screenSM, screenMD, screenLG, screenXL, screenXXL } = tokens;
  const width = window.document.documentElement.clientWidth;
  return {
    xs: width < screenXSMax,
    sm: width >= screenSM,
    md: width >= screenMD,
    lg: width >= screenLG,
    xl: width >= screenXL,
    xxl: width >= screenXXL
  };
};

const useIsMobile = () => {
  // When a breakpoint is true, all the breakpoints above it are also true.
  const { token: tokens } = theme.useToken();
  const [initialBreakpoints] = useState(() => getInitialBreakpoints(tokens));
  const dynamicBreakpoints = useBreakpoint();
  const { sm, md, xl, xxl } = { ...initialBreakpoints, ...dynamicBreakpoints };
  return {
    isMobile: Boolean(!md),
    isDesktop: Boolean(md),
    isLargeDesktop: Boolean(xl),
    isWideDesktop: Boolean(xxl),
    isLandscapeMobile: Boolean(sm)
  };
};

export default useIsMobile;
